export const noPassengers = {
  adultsWheelchair: 0,
  childrenWheelchair: 0,
  guideDogs: 0,
  wheelchairCompanions: 0,
  nonWheelchairCompanions: 0,
  adults: 0,
  adults12To15: 0,
  adults16Plus: 0,
  children: 0,
  youths: 0,
  seniors: 0,
  children4Only: 0,
  children5To11: 0,
  infants: 0,
  seatedInfants: 0
};

export const searchTypes = {
  STANDARD: 'standard',
  GROUP: 'group',
  WITH_DISABILITY: 'withDisability'
};

export const disabilityTypes = {
  WHEELCHAIR: 'wheelchair',
  NON_WHEELCHAIR: 'nonWheelchair',
  COMPANION_ONLY: 'companionOnly',
  ASSISTANCE_DOG_ONLY: 'assistanceDogOnly'
};
